/** CSS class applied to all disclosure buttons */
export const DISCLOSURE_BUTTON_CLASS = 'ss-menu-disclosure-button';

/** CSS class for top-level disclosure buttons (visually hidden until focused) */
export const TOP_LEVEL_BUTTON_CLASS = 'ss-menu-disclosure-button-top-level';

/** CSS class for submenu disclosure buttons (always visible) */
export const SUBMENU_BUTTON_CLASS = 'ss-menu-disclosure-button-submenu';

/** CSS class for the SVG arrow inside disclosure buttons */
export const ARROW_CLASS = 'ss-menu-disclosure-arrow';

/**
 * SVG arrow markup.
 * Must stay in sync with SiteHeaderAbstract::getSubmenuSVG in the PHP codebase.
 */
export const ARROW_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none" class="${ARROW_CLASS}" aria-hidden="true"><path d="M4 2L8 6L4 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>`;
